import { defineDomainTranslations } from './defineDomainTranslations';

const EN_ACCOUNT_TRANSLATIONS = {
  'account.actions.cancel': 'Cancel',
  'account.actions.delete': 'Delete',
  'account.actions.save': 'Save',
  'account.addEmail.confirmTitle': 'Confirm your email address',
  'account.addEmail.emailLabel': 'Email',
  'account.addEmail.emailMismatch': "Email addresses don't match",
  'account.addEmail.emailPlaceholder': 'Your email',
  'account.addEmail.incorrectEmail': 'Incorrect email',
  'account.addEmail.nextQuestion': 'Continue',
  'account.addEmail.repeatEmailLabel': 'Repeat email',
  'account.addEmail.subtitle': 'Double-checking ensures you can always access your account',
  'account.api.clientId': 'API Client ID',
  'account.api.code': 'API key',
  'account.api.generateAction': 'Generate API key',
  'account.api.generateSubtitle': 'Generate a key to start using the API',
  'account.api.generateTitle': 'Generate API key',
  'account.api.readDocumentation': 'Read documentation',
  'account.api.renewAction': 'Renew subscription',
  'account.api.renewTitle': 'Renew your subscription to access the API',
  'account.api.startTitle': 'Start using our API',
  'account.api.upgradeAction': 'Upgrade plan',
  'account.api.upgradeSubtitle': 'Upgrade to a Business or Enterprise plan to access the API',
  'account.copy.copied': 'Copied',
  'account.copy.copy': 'Copy',
  'account.credits.availableForTranslation': 'Translation minutes available: {minutes}. {schedule}',
  'account.credits.availableForTranslationAndLipSync':
    'Minutes available for translation or lip-sync: {minutes}. {schedule}',
  'account.credits.buyAdditional': 'Buy additional minutes',
  'account.credits.buyMinutesMessage': 'To continue using Rask, buy more minutes.',
  'account.credits.buyMore': 'Buy more minutes',
  'account.credits.manageSubscriptionMessage': 'To continue using Rask, manage your subscription.',
  'account.credits.minutesAddedInDay': '{minutes} new minutes will be added in {days} day.',
  'account.credits.minutesAddedInDays': '{minutes} new minutes will be added in {days} days.',
  'account.credits.minutesAddedToday': '{minutes} new minutes will be added today.',
  'account.credits.moreMinutes': 'More minutes',
  'account.credits.recording': 'Recording',
  'account.credits.recordingAlt': 'Rask screen recorder',
  'account.credits.rolloverHint':
    'Unused minutes will roll over to the next month while your subscription remains active.',
  'account.credits.translation': 'Translation',
  'account.credits.unlockFull': 'Unlock full version',
  'account.credits.upgrade': 'Upgrade',
  'account.credits.usageMinutes': 'Used: {used} min • Left: {left} min',
  'account.credits.usageVideos': 'Videos used: {used} • Videos left: {left}',
  'account.credits.waitForMinutes': 'Alternatively, wait until {date}, when another {minutes} minutes will be added.',
  'account.credits.yourMinutes': 'Your minutes',
  'account.delete.action': 'Delete my account',
  'account.delete.itemCounts': 'Members: {members} • Projects: {projects}',
  'account.delete.title': 'Permanently delete your account? The following Teamspaces will also be deleted:',
  'account.delete.warning':
    'Deleting your account permanently removes all Teamspaces you created and all projects in them. Your team will lose access.',
  'account.password.change': 'Change password',
  'account.password.incorrect': 'Incorrect password',
  'account.password.newLabel': 'New password',
  'account.password.newPlaceholder': 'Enter new password',
  'account.password.oldLabel': 'Current password',
  'account.password.oldPlaceholder': 'Enter current password',
  'account.password.sameError': "Passwords can't be the same",
  'account.password.updated': 'Password updated',
  'account.profile.email': 'Email',
  'account.profile.emailUpdates': 'Email updates on new features and news',
  'account.subscription.actionCancel': 'Cancel subscription',
  'account.subscription.actionCancelDowngrade': 'Cancel downgrade',
  'account.subscription.actionChangePlan': 'Change plan',
  'account.subscription.actionManageBilling': 'Manage billing',
  'account.subscription.actionRenew': 'Renew subscription',
  'account.subscription.activeEnterprise': 'Your subscription ends on {date}.',
  'account.subscription.annual': 'annual',
  'account.subscription.canceled': 'Your subscription was canceled. Renew it to continue translating your videos.',
  'account.subscription.cancellationFailed': 'Unable to cancel. Please try again.',
  'account.subscription.cancellationScheduled': 'Cancellation scheduled',
  'account.subscription.ending': 'Your subscription ends on {date}.',
  'account.subscription.expired': 'Your subscription has expired. Renew it to continue translating your videos.',
  'account.subscription.fromDate': 'From {date}',
  'account.subscription.month': 'month',
  'account.subscription.monthly': 'monthly',
  'account.subscription.pastDue':
    'Your subscription and boosters are paused after a failed payment. Update your payment details to keep using Rask.',
  'account.subscription.paused':
    'Your subscription is paused. Renew it or contact us in the support chat to continue translating your videos.',
  'account.subscription.planName': '{planName} plan',
  'account.subscription.remainingExpires':
    'Any remaining minutes will expire after this date. Renew your subscription to keep using them.',
  'account.subscription.renews': 'Your subscription will automatically renew on {date} at {price} per {interval}.',
  'account.subscription.scheduled':
    'Your {currentInterval} {currentPlan} subscription is active until {date}. On {changeDate}, it will automatically change to the {nextInterval} {nextPlan} plan at {price} per {interval}.',
  'account.subscription.statusActive': 'Active',
  'account.subscription.statusCanceled': 'Canceled',
  'account.subscription.statusExpired': 'Expired',
  'account.subscription.statusPastDue': 'Past due',
  'account.subscription.statusPaused': 'Paused',
  'account.subscription.statusScheduled': 'Scheduled',
  'account.subscription.statusTrial': 'Trial',
  'account.subscription.statusTrialing': 'Trial',
  'account.subscription.statusUnpaid': 'Unpaid',
  'account.subscription.trialContactAfter': 'to explore the options that best fit your needs.',
  'account.subscription.trialContactBefore':
    'Your trial ends on {date}. To choose a plan, visit Pricing or contact our partnership specialist',
  'account.subscription.year': 'year',
  'account.subscription.yearly': 'yearly',
  'account.trialUpgrade.apiAccess': 'API access',
  'account.trialUpgrade.customVoices': 'Customize cloned voices and save them to your library',
  'account.trialUpgrade.dictionary': 'Save custom translations in the dictionary',
  'account.trialUpgrade.downloadSrt': 'Download subtitle files',
  'account.trialUpgrade.lipSync': 'Apply lip-sync',
  'account.trialUpgrade.subtitles': 'Add subtitles to your video',
  'account.trialUpgrade.teamspaces': 'Create Teamspaces and collaborate with your team',
  'account.trialUpgrade.title': 'Upgrade for full access',
  'account.trialUpgrade.translate': 'Translate video and audio into 135+ languages',
  'account.trialUpgrade.upgradePlan': 'Upgrade plan',
  'account.trialUpgrade.uploadSrt': 'Upload an SRT file with your video',
  'account.trialUpgrade.voiceClone': 'Clone voices in 32 languages',
} as const;

export const ACCOUNT_TRANSLATIONS = defineDomainTranslations({
  en: EN_ACCOUNT_TRANSLATIONS,
  es: {
    'account.actions.cancel': 'Cancelar',
    'account.actions.delete': 'Eliminar',
    'account.actions.save': 'Guardar',
    'account.addEmail.confirmTitle': 'Confirma tu dirección de correo electrónico',
    'account.addEmail.emailLabel': 'Correo electrónico',
    'account.addEmail.emailMismatch': 'Las direcciones de correo electrónico no coinciden',
    'account.addEmail.emailPlaceholder': 'Tu correo electrónico',
    'account.addEmail.incorrectEmail': 'Correo electrónico incorrecto',
    'account.addEmail.nextQuestion': 'Siguiente pregunta',
    'account.addEmail.repeatEmailLabel': 'Repite el correo electrónico',
    'account.addEmail.subtitle':
      'Comprobar dos veces tu dirección de correo electrónico garantiza que siempre puedas acceder a tu cuenta',
    'account.api.clientId': 'ID de cliente de la API',
    'account.api.code': 'Clave de API',
    'account.api.generateAction': 'Generar clave de API',
    'account.api.generateSubtitle': 'Genera una clave para empezar a usar la API',
    'account.api.generateTitle': 'Generar clave de API',
    'account.api.readDocumentation': 'Leer la documentación',
    'account.api.renewAction': 'Renovar suscripción',
    'account.api.renewTitle': 'Renueva tu suscripción para acceder a la API',
    'account.api.startTitle': 'Empieza a usar nuestra API',
    'account.api.upgradeAction': 'Mejorar el plan',
    'account.api.upgradeSubtitle': 'Cámbiate a un plan Business o Enterprise para acceder a la API',
    'account.copy.copied': 'Copiado',
    'account.copy.copy': 'Copiar',
    'account.credits.availableForTranslation': 'Minutos disponibles para traducción: {minutes}. {schedule}',
    'account.credits.availableForTranslationAndLipSync':
      'Minutos disponibles para traducción o Lip-sync: {minutes}. {schedule}',
    'account.credits.buyAdditional': 'Comprar minutos adicionales',
    'account.credits.buyMinutesMessage': 'Para seguir usando Rask, compra más minutos.',
    'account.credits.buyMore': 'Comprar más minutos',
    'account.credits.manageSubscriptionMessage': 'Para seguir usando Rask, gestiona tu suscripción.',
    'account.credits.minutesAddedInDay': 'Dentro de {days} día se añadirán nuevos minutos: {minutes}.',
    'account.credits.minutesAddedInDays': 'Dentro de {days} días se añadirán nuevos minutos: {minutes}.',
    'account.credits.minutesAddedToday': 'Hoy se añadirán nuevos minutos: {minutes}.',
    'account.credits.moreMinutes': 'Más minutos',
    'account.credits.recording': 'Grabación',
    'account.credits.recordingAlt': 'Grabador de pantalla de Rask',
    'account.credits.rolloverHint':
      'Los minutos no utilizados pasarán al mes siguiente mientras tu suscripción siga activa.',
    'account.credits.translation': 'Traducción',
    'account.credits.unlockFull': 'Desbloquear la versión completa',
    'account.credits.upgrade': 'Mejorar el plan',
    'account.credits.usageMinutes': 'Usados: {used} min • Restantes: {left} min',
    'account.credits.usageVideos': 'Videos usados: {used} • Videos restantes: {left}',
    'account.credits.waitForMinutes':
      'También puedes esperar hasta el {date}, cuando se añadirán más minutos: {minutes}.',
    'account.credits.yourMinutes': 'Tus minutos',
    'account.delete.action': 'Eliminar mi cuenta',
    'account.delete.itemCounts': 'Miembros: {members} • Proyectos: {projects}',
    'account.delete.title':
      '¿Quieres eliminar tu cuenta definitivamente? También se eliminarán los siguientes Teamspaces:',
    'account.delete.warning':
      'Al eliminar tu cuenta se borrarán de forma permanente todos los Teamspaces y proyectos que hayas creado. Tu equipo perderá el acceso.',
    'account.password.change': 'Cambiar contraseña',
    'account.password.incorrect': 'Contraseña incorrecta',
    'account.password.newLabel': 'Nueva contraseña',
    'account.password.newPlaceholder': 'Introduce la nueva contraseña',
    'account.password.oldLabel': 'Contraseña actual',
    'account.password.oldPlaceholder': 'Introduce la contraseña actual',
    'account.password.sameError': 'Las contraseñas no pueden ser iguales',
    'account.password.updated': 'Contraseña actualizada',
    'account.profile.email': 'Correo electrónico',
    'account.profile.emailUpdates': 'Novedades por correo sobre funciones y noticias',
    'account.subscription.actionCancel': 'Cancelar suscripción',
    'account.subscription.actionCancelDowngrade': 'Cancelar cambio a un plan inferior',
    'account.subscription.actionChangePlan': 'Cambiar plan',
    'account.subscription.actionManageBilling': 'Gestionar facturación',
    'account.subscription.actionRenew': 'Renovar suscripción',
    'account.subscription.activeEnterprise': 'Tu suscripción termina el {date}.',
    'account.subscription.annual': 'anual',
    'account.subscription.canceled': 'Tu suscripción se ha cancelado. Renuévala para seguir traduciendo tus videos.',
    'account.subscription.cancellationFailed': 'No se pudo cancelar la suscripción. Inténtalo de nuevo.',
    'account.subscription.cancellationScheduled': 'Cancelación programada',
    'account.subscription.ending': 'Tu suscripción termina el {date}.',
    'account.subscription.expired': 'Tu suscripción ha caducado. Renuévala para seguir traduciendo tus videos.',
    'account.subscription.fromDate': 'A partir del {date}',
    'account.subscription.month': 'mes',
    'account.subscription.monthly': 'mensual',
    'account.subscription.pastDue':
      'Tu suscripción y tus Boosters están pausados tras un pago fallido. Actualiza los datos de pago para seguir usando Rask.',
    'account.subscription.paused':
      'Tu suscripción está pausada. Renuévala o contáctanos en el chat de soporte para seguir traduciendo tus videos.',
    'account.subscription.planName': 'Plan {planName}',
    'account.subscription.remainingExpires':
      'Los minutos restantes caducarán después de esta fecha. Renueva tu suscripción para seguir utilizándolos.',
    'account.subscription.renews': 'Tu suscripción se renovará automáticamente el {date} por {price} al {interval}.',
    'account.subscription.scheduled':
      'Tu suscripción {currentPlan} {currentInterval} está activa hasta el {date}. El {changeDate}, cambiará automáticamente al plan {nextPlan} {nextInterval} por {price} al {interval}.',
    'account.subscription.statusActive': 'Activa',
    'account.subscription.statusCanceled': 'Cancelada',
    'account.subscription.statusExpired': 'Caducada',
    'account.subscription.statusPastDue': 'Pago atrasado',
    'account.subscription.statusPaused': 'Pausada',
    'account.subscription.statusScheduled': 'Programado',
    'account.subscription.statusTrial': 'Prueba',
    'account.subscription.statusTrialing': 'En prueba',
    'account.subscription.statusUnpaid': 'Sin pagar',
    'account.subscription.trialContactAfter': 'para conocer las opciones que mejor se adapten a tus necesidades.',
    'account.subscription.trialContactBefore':
      'Tu prueba termina el {date}. Para elegir un plan, visita Precios o contacta con nuestro equipo de colaboraciones en',
    'account.subscription.year': 'año',
    'account.subscription.yearly': 'anual',
    'account.trialUpgrade.apiAccess': 'Acceso a la API',
    'account.trialUpgrade.customVoices': 'Personaliza voces clonadas y guárdalas en tu biblioteca',
    'account.trialUpgrade.dictionary': 'Guarda traducciones personalizadas en el diccionario',
    'account.trialUpgrade.downloadSrt': 'Descarga archivos de subtítulos',
    'account.trialUpgrade.lipSync': 'Aplica Lip-sync',
    'account.trialUpgrade.subtitles': 'Añade subtítulos a tu video',
    'account.trialUpgrade.teamspaces': 'Crea Teamspaces y colabora con tu equipo',
    'account.trialUpgrade.title': 'Actualiza tu plan para obtener acceso completo',
    'account.trialUpgrade.translate': 'Traduce video y audio a más de 135 idiomas',
    'account.trialUpgrade.upgradePlan': 'Actualizar el plan',
    'account.trialUpgrade.uploadSrt': 'Sube un archivo SRT con tu video',
    'account.trialUpgrade.voiceClone': 'Clona voces en 32 idiomas',
  },
  fr: {
    'account.actions.cancel': 'Annuler',
    'account.actions.delete': 'Supprimer',
    'account.actions.save': 'Enregistrer',
    'account.addEmail.confirmTitle': 'Confirmez votre adresse e-mail',
    'account.addEmail.emailLabel': 'E-mail',
    'account.addEmail.emailMismatch': 'Les adresses e-mail ne correspondent pas',
    'account.addEmail.emailPlaceholder': 'Votre e-mail',
    'account.addEmail.incorrectEmail': 'Adresse e-mail incorrecte',
    'account.addEmail.nextQuestion': 'Question suivante',
    'account.addEmail.repeatEmailLabel': 'Saisissez à nouveau votre adresse e-mail',
    'account.addEmail.subtitle': 'Cette vérification garantit que vous pourrez toujours accéder à votre compte',
    'account.api.clientId': 'Identifiant client API',
    'account.api.code': 'Clé API',
    'account.api.generateAction': 'Générer une clé API',
    'account.api.generateSubtitle': "Générez une clé pour commencer à utiliser l'API",
    'account.api.generateTitle': 'Générer une clé API',
    'account.api.readDocumentation': 'Lire la documentation',
    'account.api.renewAction': "Renouveler l'abonnement",
    'account.api.renewTitle': "Renouvelez votre abonnement pour accéder à l'API",
    'account.api.startTitle': 'Commencez à utiliser notre API',
    'account.api.upgradeAction': 'Passer à un forfait supérieur',
    'account.api.upgradeSubtitle': 'Passez au forfait Business ou Enterprise pour vous connecter',
    'account.copy.copied': 'Copié',
    'account.copy.copy': 'Copier',
    'account.credits.availableForTranslation': 'Minutes disponibles pour la traduction : {minutes}. {schedule}',
    'account.credits.availableForTranslationAndLipSync':
      'Minutes disponibles pour la traduction ou le Lip-sync : {minutes}. {schedule}',
    'account.credits.buyAdditional': 'Acheter des minutes supplémentaires',
    'account.credits.buyMinutesMessage': 'Pour continuer à utiliser Rask, achetez plus de minutes.',
    'account.credits.buyMore': 'Acheter plus de minutes',
    'account.credits.manageSubscriptionMessage': 'Pour continuer à utiliser Rask, gérez votre abonnement.',
    'account.credits.minutesAddedInDay': 'Dans {days} jour, des minutes seront ajoutées : {minutes}.',
    'account.credits.minutesAddedInDays': 'Dans {days} jours, des minutes seront ajoutées : {minutes}.',
    'account.credits.minutesAddedToday': 'Des minutes seront ajoutées aujourd’hui : {minutes}.',
    'account.credits.moreMinutes': 'Plus de minutes',
    'account.credits.recording': 'Enregistrement',
    'account.credits.recordingAlt': 'Enregistreur d’écran Rask',
    'account.credits.rolloverHint':
      'Les minutes inutilisées seront reportées au mois suivant tant que votre abonnement reste actif.',
    'account.credits.translation': 'Traduction',
    'account.credits.unlockFull': 'Débloquer la version complète',
    'account.credits.upgrade': 'Mettre à niveau',
    'account.credits.usageMinutes': 'Utilisées : {used} min • Restantes : {left} min',
    'account.credits.usageVideos': 'Vidéos utilisées : {used} • Vidéos restantes : {left}',
    'account.credits.waitForMinutes':
      "Vous pouvez aussi attendre jusqu'au {date}, lorsque des minutes supplémentaires seront ajoutées : {minutes}.",
    'account.credits.yourMinutes': 'Vos minutes',
    'account.delete.action': 'Supprimer mon compte',
    'account.delete.itemCounts': 'Membres : {members} • Projets : {projects}',
    'account.delete.title':
      'Supprimer définitivement votre compte ? Les Teamspaces suivants seront également supprimés :',
    'account.delete.warning':
      "La suppression de votre compte effacera définitivement tous les Teamspaces et projets que vous avez créés. Votre équipe n'y aura plus accès.",
    'account.password.change': 'Modifier le mot de passe',
    'account.password.incorrect': 'Mot de passe incorrect',
    'account.password.newLabel': 'Nouveau mot de passe',
    'account.password.newPlaceholder': 'Saisissez le nouveau mot de passe',
    'account.password.oldLabel': 'Mot de passe actuel',
    'account.password.oldPlaceholder': 'Saisissez le mot de passe actuel',
    'account.password.sameError': 'Les mots de passe doivent être différents',
    'account.password.updated': 'Mot de passe mis à jour',
    'account.profile.email': 'E-mail',
    'account.profile.emailUpdates': 'Actualités par e-mail sur les nouvelles fonctionnalités et autres nouveautés',
    'account.subscription.actionCancel': "Résilier l'abonnement",
    'account.subscription.actionCancelDowngrade': 'Annuler le passage au forfait inférieur',
    'account.subscription.actionChangePlan': 'Changer de forfait',
    'account.subscription.actionManageBilling': 'Gérer la facturation',
    'account.subscription.actionRenew': "Renouveler l'abonnement",
    'account.subscription.activeEnterprise': 'Votre abonnement prend fin le {date}.',
    'account.subscription.annual': 'annuel',
    'account.subscription.canceled':
      'Votre abonnement a été résilié. Renouvelez-le pour continuer à traduire vos vidéos.',
    'account.subscription.cancellationFailed': "Impossible de résilier l'abonnement. Veuillez réessayer.",
    'account.subscription.cancellationScheduled': 'Résiliation programmée',
    'account.subscription.ending': 'Votre abonnement prend fin le {date}.',
    'account.subscription.expired': 'Votre abonnement a expiré. Renouvelez-le pour continuer à traduire vos vidéos.',
    'account.subscription.fromDate': 'À partir du {date}',
    'account.subscription.month': 'mois',
    'account.subscription.monthly': 'mensuel',
    'account.subscription.pastDue':
      'Votre abonnement et vos Boosters sont suspendus après un échec de paiement. Mettez à jour vos informations de paiement pour continuer à utiliser Rask.',
    'account.subscription.paused':
      "Votre abonnement est suspendu. Renouvelez-le ou contactez-nous dans le chat d'assistance pour continuer à traduire vos vidéos.",
    'account.subscription.planName': 'Forfait {planName}',
    'account.subscription.remainingExpires':
      'Les minutes restantes expireront après cette date. Renouvelez votre abonnement pour continuer à les utiliser.',
    'account.subscription.renews':
      'Votre abonnement sera automatiquement renouvelé le {date} au prix de {price} par {interval}.',
    'account.subscription.scheduled':
      "Votre abonnement {currentPlan} {currentInterval} est actif jusqu'au {date}. Le {changeDate}, il passera automatiquement au forfait {nextPlan} {nextInterval} au prix de {price} par {interval}.",
    'account.subscription.statusActive': 'Actif',
    'account.subscription.statusCanceled': 'Résilié',
    'account.subscription.statusExpired': 'Expiré',
    'account.subscription.statusPastDue': 'Paiement en retard',
    'account.subscription.statusPaused': 'Suspendu',
    'account.subscription.statusScheduled': 'Programmé',
    'account.subscription.statusTrial': 'Essai',
    'account.subscription.statusTrialing': "Période d'essai",
    'account.subscription.statusUnpaid': 'Impayé',
    'account.subscription.trialContactAfter': 'pour découvrir les options les mieux adaptées à vos besoins.',
    'account.subscription.trialContactBefore':
      'Votre essai prend fin le {date}. Pour choisir un forfait, consultez la page Tarifs ou contactez notre spécialiste des partenariats',
    'account.subscription.year': 'an',
    'account.subscription.yearly': 'annuel',
    'account.trialUpgrade.apiAccess': "Accès à l'API",
    'account.trialUpgrade.customVoices': 'Personnalisez les voix clonées et enregistrez-les dans votre bibliothèque',
    'account.trialUpgrade.dictionary': 'Enregistrez vos traductions personnalisées dans le dictionnaire',
    'account.trialUpgrade.downloadSrt': 'Téléchargez les fichiers de sous-titres',
    'account.trialUpgrade.lipSync': 'Appliquez le Lip-sync',
    'account.trialUpgrade.subtitles': 'Ajoutez des sous-titres à votre vidéo',
    'account.trialUpgrade.teamspaces': 'Créez des Teamspaces et collaborez avec votre équipe',
    'account.trialUpgrade.title': 'Passez à un forfait supérieur pour bénéficier d’un accès complet',
    'account.trialUpgrade.translate': 'Traduisez des vidéos et des fichiers audio dans plus de 135 langues',
    'account.trialUpgrade.upgradePlan': 'Passer à un forfait supérieur',
    'account.trialUpgrade.uploadSrt': 'Importez un fichier SRT avec votre vidéo',
    'account.trialUpgrade.voiceClone': 'Clonez des voix dans 32 langues',
  },
  it: {
    'account.actions.cancel': 'Annulla',
    'account.actions.delete': 'Elimina',
    'account.actions.save': 'Salva',
    'account.addEmail.confirmTitle': 'Conferma il tuo indirizzo e-mail',
    'account.addEmail.emailLabel': 'E-mail',
    'account.addEmail.emailMismatch': 'Gli indirizzi e-mail non corrispondono',
    'account.addEmail.emailPlaceholder': 'La tua e-mail',
    'account.addEmail.incorrectEmail': 'Indirizzo e-mail non valido',
    'account.addEmail.nextQuestion': 'Domanda successiva',
    'account.addEmail.repeatEmailLabel': 'Ripeti l’e-mail',
    'account.addEmail.subtitle': 'Un doppio controllo garantisce che tu possa sempre accedere al tuo account',
    'account.api.clientId': 'ID client API',
    'account.api.code': 'Chiave API',
    'account.api.generateAction': 'Genera chiave API',
    'account.api.generateSubtitle': "Genera una chiave per iniziare a usare l'API",
    'account.api.generateTitle': 'Genera chiave API',
    'account.api.readDocumentation': 'Leggi la documentazione',
    'account.api.renewAction': "Rinnova l'abbonamento",
    'account.api.renewTitle': "Rinnova l'abbonamento per accedere all'API",
    'account.api.startTitle': 'Inizia a usare la nostra API',
    'account.api.upgradeAction': 'Passa a un piano superiore',
    'account.api.upgradeSubtitle': 'Passa al piano Business o Enterprise per collegarti',
    'account.copy.copied': 'Copiato',
    'account.copy.copy': 'Copia',
    'account.credits.availableForTranslation': 'Minuti disponibili per la traduzione: {minutes}. {schedule}',
    'account.credits.availableForTranslationAndLipSync':
      'Minuti disponibili per traduzione o lip-sync: {minutes}. {schedule}',
    'account.credits.buyAdditional': 'Acquista minuti aggiuntivi',
    'account.credits.buyMinutesMessage': 'Per continuare a usare Rask, acquista altri minuti.',
    'account.credits.buyMore': 'Acquista altri minuti',
    'account.credits.manageSubscriptionMessage': "Per continuare a usare Rask, gestisci l'abbonamento.",
    'account.credits.minutesAddedInDay': 'Tra {days} giorno riceverai altri minuti: {minutes}.',
    'account.credits.minutesAddedInDays': 'Tra {days} giorni riceverai altri minuti: {minutes}.',
    'account.credits.minutesAddedToday': 'Oggi riceverai altri minuti: {minutes}.',
    'account.credits.moreMinutes': 'Più minuti',
    'account.credits.recording': 'Registrazione',
    'account.credits.recordingAlt': 'Registratore dello schermo Rask',
    'account.credits.rolloverHint':
      "I minuti non utilizzati passeranno al mese successivo finché l'abbonamento resterà attivo.",
    'account.credits.translation': 'Traduzione',
    'account.credits.unlockFull': 'Sblocca la versione completa',
    'account.credits.upgrade': 'Passa a un piano superiore',
    'account.credits.usageMinutes': 'Usati: {used} min • Rimanenti: {left} min',
    'account.credits.usageVideos': 'Video usati: {used} • Video rimanenti: {left}',
    'account.credits.waitForMinutes':
      'In alternativa, attendi fino al {date}, quando riceverai altri minuti: {minutes}.',
    'account.credits.yourMinutes': 'I tuoi minuti',
    'account.delete.action': 'Elimina il mio account',
    'account.delete.itemCounts': 'Membri: {members} • Progetti: {projects}',
    'account.delete.title': 'Eliminare definitivamente il tuo account? Verranno eliminati anche i seguenti Teamspace:',
    'account.delete.warning':
      "L'eliminazione dell'account rimuoverà definitivamente tutti i Teamspace e i progetti che hai creato. Il tuo team perderà l'accesso.",
    'account.password.change': 'Cambia password',
    'account.password.incorrect': 'Password errata',
    'account.password.newLabel': 'Nuova password',
    'account.password.newPlaceholder': 'Inserisci la nuova password',
    'account.password.oldLabel': 'Password attuale',
    'account.password.oldPlaceholder': 'Inserisci la password attuale',
    'account.password.sameError': 'Le password devono essere diverse',
    'account.password.updated': 'Password aggiornata',
    'account.profile.email': 'E-mail',
    'account.profile.emailUpdates': 'Aggiornamenti via e-mail su novità e funzionalità',
    'account.subscription.actionCancel': "Annulla l'abbonamento",
    'account.subscription.actionCancelDowngrade': 'Annulla il downgrade',
    'account.subscription.actionChangePlan': 'Cambia piano',
    'account.subscription.actionManageBilling': 'Gestisci fatturazione',
    'account.subscription.actionRenew': "Rinnova l'abbonamento",
    'account.subscription.activeEnterprise': 'Il tuo abbonamento termina il {date}.',
    'account.subscription.annual': 'annuale',
    'account.subscription.canceled':
      'Il tuo abbonamento è stato annullato. Rinnovalo per continuare a tradurre i tuoi video.',
    'account.subscription.cancellationFailed': "Impossibile annullare l'abbonamento. Riprova.",
    'account.subscription.cancellationScheduled': 'Disdetta programmata',
    'account.subscription.ending': 'Il tuo abbonamento termina il {date}.',
    'account.subscription.expired': 'Il tuo abbonamento è scaduto. Rinnovalo per continuare a tradurre i tuoi video.',
    'account.subscription.fromDate': 'A partire da {date}',
    'account.subscription.month': 'mese',
    'account.subscription.monthly': 'mensile',
    'account.subscription.pastDue':
      'Il tuo abbonamento e i booster sono in pausa dopo un pagamento non riuscito. Aggiorna i dati di pagamento per continuare a usare Rask.',
    'account.subscription.paused':
      'Il tuo abbonamento è in pausa. Rinnovalo o contattaci nella chat di assistenza per continuare a tradurre i tuoi video.',
    'account.subscription.planName': 'Piano {planName}',
    'account.subscription.remainingExpires':
      "I minuti rimanenti scadranno dopo questa data. Rinnova l'abbonamento per continuare a usarli.",
    'account.subscription.renews':
      'Il tuo abbonamento si rinnoverà automaticamente il {date} al prezzo di {price} per {interval}.',
    'account.subscription.scheduled':
      'Il tuo abbonamento {currentPlan} {currentInterval} è attivo fino al {date}. Il {changeDate} passerà automaticamente al piano {nextPlan} {nextInterval} al prezzo di {price} per {interval}.',
    'account.subscription.statusActive': 'Attivo',
    'account.subscription.statusCanceled': 'Annullato',
    'account.subscription.statusExpired': 'Scaduto',
    'account.subscription.statusPastDue': 'Pagamento insoluto',
    'account.subscription.statusPaused': 'In pausa',
    'account.subscription.statusScheduled': 'Programmato',
    'account.subscription.statusTrial': 'Prova',
    'account.subscription.statusTrialing': 'Periodo di prova',
    'account.subscription.statusUnpaid': 'Non pagato',
    'account.subscription.trialContactAfter': 'per scoprire le opzioni più adatte alle tue esigenze.',
    'account.subscription.trialContactBefore':
      'La prova termina il {date}. Per scegliere un piano, visita la pagina Prezzi o contatta il nostro referente per le partnership',
    'account.subscription.year': 'anno',
    'account.subscription.yearly': 'annuale',
    'account.trialUpgrade.apiAccess': "Accesso all'API",
    'account.trialUpgrade.customVoices': 'Personalizza le voci clonate e salvale nella libreria',
    'account.trialUpgrade.dictionary': 'Salva le traduzioni personalizzate nel dizionario',
    'account.trialUpgrade.downloadSrt': 'Scarica i file dei sottotitoli',
    'account.trialUpgrade.lipSync': 'Applica il lip-sync',
    'account.trialUpgrade.subtitles': 'Aggiungi sottotitoli al video',
    'account.trialUpgrade.teamspaces': 'Crea Teamspace e collabora con il tuo team',
    'account.trialUpgrade.title': "Passa al piano superiore per l'accesso completo",
    'account.trialUpgrade.translate': 'Traduci video e audio in oltre 135 lingue',
    'account.trialUpgrade.upgradePlan': 'Passa a un piano superiore',
    'account.trialUpgrade.uploadSrt': 'Carica un file SRT con il video',
    'account.trialUpgrade.voiceClone': 'Clona le voci in 32 lingue',
  },
  pt: {
    'account.actions.cancel': 'Cancelar',
    'account.actions.delete': 'Excluir',
    'account.actions.save': 'Salvar',
    'account.addEmail.confirmTitle': 'Confirme seu endereço de e-mail',
    'account.addEmail.emailLabel': 'E-mail',
    'account.addEmail.emailMismatch': 'Os endereços de e-mail não coincidem',
    'account.addEmail.emailPlaceholder': 'Seu e-mail',
    'account.addEmail.incorrectEmail': 'E-mail incorreto',
    'account.addEmail.nextQuestion': 'Próxima pergunta',
    'account.addEmail.repeatEmailLabel': 'Repita o e-mail',
    'account.addEmail.subtitle': 'A verificação garante que você sempre possa acessar sua conta',
    'account.api.clientId': 'ID do cliente da API',
    'account.api.code': 'Chave da API',
    'account.api.generateAction': 'Gerar chave da API',
    'account.api.generateSubtitle': 'Gere uma chave para começar a usar a API',
    'account.api.generateTitle': 'Gerar chave da API',
    'account.api.readDocumentation': 'Ler a documentação',
    'account.api.renewAction': 'Renovar assinatura',
    'account.api.renewTitle': 'Renove sua assinatura para acessar a API',
    'account.api.startTitle': 'Comece a usar nossa API',
    'account.api.upgradeAction': 'Fazer upgrade do plano',
    'account.api.upgradeSubtitle': 'Mude para o plano Business ou Enterprise para se conectar',
    'account.copy.copied': 'Copiado',
    'account.copy.copy': 'Copiar',
    'account.credits.availableForTranslation': 'Minutos disponíveis para tradução: {minutes}. {schedule}',
    'account.credits.availableForTranslationAndLipSync':
      'Minutos disponíveis para tradução ou Lip-sync: {minutes}. {schedule}',
    'account.credits.buyAdditional': 'Comprar minutos adicionais',
    'account.credits.buyMinutesMessage': 'Para continuar usando o Rask, compre mais minutos.',
    'account.credits.buyMore': 'Comprar mais minutos',
    'account.credits.manageSubscriptionMessage': 'Para continuar usando o Rask, gerencie sua assinatura.',
    'account.credits.minutesAddedInDay': '{minutes} novos minutos serão adicionados em {days} dia.',
    'account.credits.minutesAddedInDays': '{minutes} novos minutos serão adicionados em {days} dias.',
    'account.credits.minutesAddedToday': '{minutes} novos minutos serão adicionados hoje.',
    'account.credits.moreMinutes': 'Mais minutos',
    'account.credits.recording': 'Gravação',
    'account.credits.recordingAlt': 'Gravador de tela do Rask',
    'account.credits.rolloverHint':
      'Os minutos não usados passarão para o próximo mês enquanto sua assinatura estiver ativa.',
    'account.credits.translation': 'Tradução',
    'account.credits.unlockFull': 'Desbloquear versão completa',
    'account.credits.upgrade': 'Fazer upgrade',
    'account.credits.usageMinutes': 'Usados: {used} min • Restantes: {left} min',
    'account.credits.usageVideos': 'Vídeos usados: {used} • Vídeos restantes: {left}',
    'account.credits.waitForMinutes':
      'Você também pode esperar até {date}, quando mais {minutes} minutos serão adicionados.',
    'account.credits.yourMinutes': 'Seus minutos',
    'account.delete.action': 'Excluir minha conta',
    'account.delete.itemCounts': 'Membros: {members} • Projetos: {projects}',
    'account.delete.title': 'Excluir sua conta permanentemente? Os seguintes Teamspaces também serão excluídos:',
    'account.delete.warning':
      'A exclusão da conta removerá permanentemente todos os Teamspaces e projetos que você criou. Sua equipe perderá o acesso.',
    'account.password.change': 'Alterar senha',
    'account.password.incorrect': 'Senha incorreta',
    'account.password.newLabel': 'Nova senha',
    'account.password.newPlaceholder': 'Digite a nova senha',
    'account.password.oldLabel': 'Senha atual',
    'account.password.oldPlaceholder': 'Digite a senha atual',
    'account.password.sameError': 'As senhas precisam ser diferentes',
    'account.password.updated': 'Senha atualizada',
    'account.profile.email': 'E-mail',
    'account.profile.emailUpdates': 'Novidades por e-mail sobre recursos e notícias',
    'account.subscription.actionCancel': 'Cancelar assinatura',
    'account.subscription.actionCancelDowngrade': 'Cancelar mudança para plano inferior',
    'account.subscription.actionChangePlan': 'Alterar plano',
    'account.subscription.actionManageBilling': 'Gerenciar faturamento',
    'account.subscription.actionRenew': 'Renovar assinatura',
    'account.subscription.activeEnterprise': 'Sua assinatura termina em {date}.',
    'account.subscription.annual': 'anual',
    'account.subscription.canceled': 'Sua assinatura foi cancelada. Renove-a para continuar traduzindo seus vídeos.',
    'account.subscription.cancellationFailed': 'Não foi possível cancelar a assinatura. Tente novamente.',
    'account.subscription.cancellationScheduled': 'Cancelamento agendado',
    'account.subscription.ending': 'Sua assinatura termina em {date}.',
    'account.subscription.expired': 'Sua assinatura expirou. Renove-a para continuar traduzindo seus vídeos.',
    'account.subscription.fromDate': 'A partir de {date}',
    'account.subscription.month': 'mês',
    'account.subscription.monthly': 'mensal',
    'account.subscription.pastDue':
      'Sua assinatura e seus Boosters estão pausados após uma falha no pagamento. Atualize os dados de pagamento para continuar usando o Rask.',
    'account.subscription.paused':
      'Sua assinatura está pausada. Renove-a ou fale conosco no chat de suporte para continuar traduzindo seus vídeos.',
    'account.subscription.planName': 'Plano {planName}',
    'account.subscription.remainingExpires':
      'Os minutos restantes expirarão após essa data. Renove sua assinatura para continuar usando-os.',
    'account.subscription.renews':
      'Sua assinatura será renovada automaticamente em {date} por {price} a cada {interval}.',
    'account.subscription.scheduled':
      'Sua assinatura {currentPlan} {currentInterval} está ativa até {date}. Em {changeDate}, ela mudará automaticamente para o plano {nextPlan} {nextInterval} por {price} a cada {interval}.',
    'account.subscription.statusActive': 'Ativa',
    'account.subscription.statusCanceled': 'Cancelada',
    'account.subscription.statusExpired': 'Expirada',
    'account.subscription.statusPastDue': 'Pagamento em atraso',
    'account.subscription.statusPaused': 'Pausada',
    'account.subscription.statusScheduled': 'Programada',
    'account.subscription.statusTrial': 'Teste',
    'account.subscription.statusTrialing': 'Em teste',
    'account.subscription.statusUnpaid': 'Não paga',
    'account.subscription.trialContactAfter': 'para conhecer as opções mais adequadas às suas necessidades.',
    'account.subscription.trialContactBefore':
      'Seu teste termina em {date}. Para escolher um plano, visite a página de Preços ou fale com nossa especialista em parcerias',
    'account.subscription.year': 'ano',
    'account.subscription.yearly': 'anual',
    'account.trialUpgrade.apiAccess': 'Acesso à API',
    'account.trialUpgrade.customVoices': 'Personalize vozes clonadas e salve-as na biblioteca',
    'account.trialUpgrade.dictionary': 'Salve traduções personalizadas no dicionário',
    'account.trialUpgrade.downloadSrt': 'Baixe arquivos de legenda',
    'account.trialUpgrade.lipSync': 'Aplique Lip-sync',
    'account.trialUpgrade.subtitles': 'Adicione legendas ao seu vídeo',
    'account.trialUpgrade.teamspaces': 'Crie Teamspaces e colabore com sua equipe',
    'account.trialUpgrade.title': 'Faça upgrade para ter acesso completo',
    'account.trialUpgrade.translate': 'Traduza vídeo e áudio para mais de 135 idiomas',
    'account.trialUpgrade.upgradePlan': 'Fazer upgrade do plano',
    'account.trialUpgrade.uploadSrt': 'Envie um arquivo SRT com seu vídeo',
    'account.trialUpgrade.voiceClone': 'Clone vozes em 32 idiomas',
  },
  ru: {
    'account.actions.cancel': 'Отмена',
    'account.actions.delete': 'Удалить',
    'account.actions.save': 'Сохранить',
    'account.addEmail.confirmTitle': 'Подтвердите адрес электронной почты',
    'account.addEmail.emailLabel': 'Электронная почта',
    'account.addEmail.emailMismatch': 'Адреса электронной почты не совпадают',
    'account.addEmail.emailPlaceholder': 'Ваш адрес электронной почты',
    'account.addEmail.incorrectEmail': 'Некорректный адрес электронной почты',
    'account.addEmail.nextQuestion': 'Продолжить',
    'account.addEmail.repeatEmailLabel': 'Повторите адрес электронной почты',
    'account.addEmail.subtitle': 'Проверка адреса поможет вам всегда сохранять доступ к аккаунту',
    'account.api.clientId': 'Идентификатор клиента API',
    'account.api.code': 'Ключ API',
    'account.api.generateAction': 'Создать ключ API',
    'account.api.generateSubtitle': 'Создайте ключ, чтобы начать работу с API',
    'account.api.generateTitle': 'Создать ключ API',
    'account.api.readDocumentation': 'Открыть документацию',
    'account.api.renewAction': 'Продлить подписку',
    'account.api.renewTitle': 'Продлите подписку, чтобы получить доступ к API',
    'account.api.startTitle': 'Начните работу с нашим API',
    'account.api.upgradeAction': 'Повысить тариф',
    'account.api.upgradeSubtitle': 'Перейдите на тариф Business или Enterprise, чтобы получить доступ к API',
    'account.copy.copied': 'Скопировано',
    'account.copy.copy': 'Копировать',
    'account.credits.availableForTranslation': 'Доступные минуты для перевода: {minutes}. {schedule}',
    'account.credits.availableForTranslationAndLipSync':
      'Доступные минуты для перевода или липсинка: {minutes}. {schedule}',
    'account.credits.buyAdditional': 'Купить дополнительные минуты',
    'account.credits.buyMinutesMessage': 'Чтобы продолжить работу в Rask, купите дополнительные минуты.',
    'account.credits.buyMore': 'Купить ещё минуты',
    'account.credits.manageSubscriptionMessage': 'Чтобы продолжить работу в Rask, перейдите к управлению подпиской.',
    'account.credits.minutesAddedInDay': 'Новые минуты ({minutes}) будут начислены через {days} дн.',
    'account.credits.minutesAddedInDays': 'Новые минуты ({minutes}) будут начислены через {days} дн.',
    'account.credits.minutesAddedToday': 'Сегодня будут начислены новые минуты: {minutes}.',
    'account.credits.moreMinutes': 'Больше минут',
    'account.credits.recording': 'Запись',
    'account.credits.recordingAlt': 'Средство записи экрана Rask',
    'account.credits.rolloverHint': 'Неиспользованные минуты переносятся на следующий месяц, пока подписка активна.',
    'account.credits.translation': 'Перевод',
    'account.credits.unlockFull': 'Открыть полную версию',
    'account.credits.upgrade': 'Улучшить тариф',
    'account.credits.usageMinutes': 'Использовано: {used} мин • Осталось: {left} мин',
    'account.credits.usageVideos': 'Обработано видео: {used} • Осталось: {left}',
    'account.credits.waitForMinutes': 'Или дождитесь {date}: тогда будут начислены дополнительные минуты ({minutes}).',
    'account.credits.yourMinutes': 'Ваши минуты',
    'account.delete.action': 'Удалить мой аккаунт',
    'account.delete.itemCounts': 'Участников: {members} • Проектов: {projects}',
    'account.delete.title': 'Удалить аккаунт навсегда? Вместе с ним будут удалены следующие пространства:',
    'account.delete.warning':
      'При удалении аккаунта навсегда удалятся все созданные вами пространства и все проекты в них. Ваша команда потеряет к ним доступ.',
    'account.password.change': 'Изменить пароль',
    'account.password.incorrect': 'Неверный пароль',
    'account.password.newLabel': 'Новый пароль',
    'account.password.newPlaceholder': 'Введите новый пароль',
    'account.password.oldLabel': 'Текущий пароль',
    'account.password.oldPlaceholder': 'Введите текущий пароль',
    'account.password.sameError': 'Новый пароль должен отличаться от текущего',
    'account.password.updated': 'Пароль изменён',
    'account.profile.email': 'Электронная почта',
    'account.profile.emailUpdates': 'Получать письма о новых функциях и новостях',
    'account.subscription.actionCancel': 'Отменить подписку',
    'account.subscription.actionCancelDowngrade': 'Отменить понижение тарифа',
    'account.subscription.actionChangePlan': 'Изменить тариф',
    'account.subscription.actionManageBilling': 'Управлять оплатой',
    'account.subscription.actionRenew': 'Продлить подписку',
    'account.subscription.activeEnterprise': 'Подписка действует до {date}.',
    'account.subscription.annual': 'годовая',
    'account.subscription.canceled': 'Подписка отменена. Продлите её, чтобы продолжить переводить видео.',
    'account.subscription.cancellationFailed': 'Не удалось отменить подписку. Попробуйте ещё раз.',
    'account.subscription.cancellationScheduled': 'Отмена подписки запланирована',
    'account.subscription.ending': 'Подписка действует до {date}.',
    'account.subscription.expired': 'Срок подписки истёк. Продлите её, чтобы продолжить переводить видео.',
    'account.subscription.fromDate': 'С {date}',
    'account.subscription.month': 'месяц',
    'account.subscription.monthly': 'ежемесячная',
    'account.subscription.pastDue':
      'Подписка и бустеры приостановлены из-за неудачной оплаты. Обновите платёжные данные, чтобы продолжить работу в Rask.',
    'account.subscription.paused':
      'Подписка приостановлена. Продлите её или напишите в чат поддержки, чтобы продолжить переводить видео.',
    'account.subscription.planName': 'Тариф {planName}',
    'account.subscription.remainingExpires':
      'Оставшиеся минуты сгорят после этой даты. Продлите подписку, чтобы продолжить ими пользоваться.',
    'account.subscription.renews': 'Подписка автоматически продлится {date}: {price} за {interval}.',
    'account.subscription.scheduled':
      'Текущая подписка {currentPlan} ({currentInterval}) действует до {date}. {changeDate} автоматически начнёт действовать {nextInterval} подписка по тарифу {nextPlan} стоимостью {price} за {interval}.',
    'account.subscription.statusActive': 'Активна',
    'account.subscription.statusCanceled': 'Отменена',
    'account.subscription.statusExpired': 'Истекла',
    'account.subscription.statusPastDue': 'Оплата просрочена',
    'account.subscription.statusPaused': 'Приостановлена',
    'account.subscription.statusScheduled': 'Запланирована',
    'account.subscription.statusTrial': 'Пробный период',
    'account.subscription.statusTrialing': 'Пробный период',
    'account.subscription.statusUnpaid': 'Не оплачена',
    'account.subscription.trialContactAfter': 'для подбора подходящего варианта.',
    'account.subscription.trialContactBefore':
      'Пробный период закончится {date}. Выберите тариф на странице цен или свяжитесь с нашим специалистом по партнёрствам',
    'account.subscription.year': 'год',
    'account.subscription.yearly': 'годовая',
    'account.trialUpgrade.apiAccess': 'Доступ к API',
    'account.trialUpgrade.customVoices': 'Настраивайте клонированные голоса и сохраняйте их в библиотеку',
    'account.trialUpgrade.dictionary': 'Сохраняйте собственные варианты перевода в словаре',
    'account.trialUpgrade.downloadSrt': 'Скачивайте файлы субтитров',
    'account.trialUpgrade.lipSync': 'Используйте липсинк',
    'account.trialUpgrade.subtitles': 'Добавляйте субтитры к видео',
    'account.trialUpgrade.teamspaces': 'Создавайте командные пространства и работайте вместе с командой',
    'account.trialUpgrade.title': 'Перейдите на тариф с полным доступом',
    'account.trialUpgrade.translate': 'Переводите видео и аудио на 135+ языков',
    'account.trialUpgrade.upgradePlan': 'Улучшить тариф',
    'account.trialUpgrade.uploadSrt': 'Загружайте SRT-файл вместе с видео',
    'account.trialUpgrade.voiceClone': 'Клонируйте голоса на 32 языках',
  },
});
